import { Avatar } from "~/components/Avatar";
import { PrimaryButton } from "~/components/Button";
import { Text } from "~/components/Text";

type Member = {
  node: {
    user: {
      id: string;
      firstName: string;
      name: string;
      profileImageUrl: string;
    };
  };
};

type JoinClubCardProps = {
  members: Member[];
  totalSize: number;
  onJoin: () => void;
  onMembers: () => void;
  className?: string;
};

export function JoinClubCard({
  members,
  totalSize,
  onJoin,
  onMembers,
  className = "",
}: JoinClubCardProps) {
  const heading =
    totalSize > 0
      ? `${totalSize.toLocaleString()} ${
          totalSize === 1 ? "person is" : "people are"
        } already in the club`
      : "Be the first to join the club";

  return (
    <section
      className={`rounded-lg bg-gradient-to-r from-butter-lime via-butter-cream to-butter-pink p-[1.5px] shadow-[0_2px_24px_-12px_rgba(243,86,79,0.45)] ${className}`}
    >
      <div className="flex flex-col gap-3 rounded-[7px] bg-butter-cream-light p-5 sm:p-6">
        <div className="flex flex-col gap-1.5">
          <Text variant="primary" size="sm" as="h2">
            {heading}
          </Text>
          <Text variant="secondary" size="sm" className="leading-snug">
            Join the group chats, DM with members, and access plans before they
            go public.
          </Text>
        </div>

        {members.length > 0 && (
          <button
            type="button"
            onClick={onMembers}
            className="flex cursor-pointer items-center gap-3 text-left"
          >
            <div className="flex -space-x-1.5">
              {members.slice(0, 7).map((member) => (
                <Avatar
                  key={member.node.user.id}
                  user={member.node.user}
                  size={30}
                  rounded
                />
              ))}
            </div>
            <Text as="span" variant="secondary" size="sm">
              {totalSize === 1 ? "1 member" : `${totalSize} members`}
            </Text>
          </button>
        )}

        <PrimaryButton
          theme="red"
          onClick={onJoin}
          className="w-full font-bold"
        >
          Join the club
        </PrimaryButton>
      </div>
    </section>
  );
}
